var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicWandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.99658,
    y: 2.99609,
    width: 18.0075,
    height: 18.0075,
    rx: 4,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M9.49909 14.4932L6.99805 17.0025",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1312 14.6593L11.4696 12.5309L9.34113 11.8692C9.16429 11.8142 9.034 11.6636 9.00503 11.4807C8.97606 11.2978 9.05344 11.1143 9.20463 11.0074L11.0244 9.72048L10.9959 7.49179C10.9935 7.30661 11.0965 7.13614 11.2615 7.05206C11.4265 6.96798 11.6249 6.98487 11.7733 7.09563L13.5597 8.42878L15.6705 7.71299C15.8458 7.65352 16.0398 7.69877 16.1707 7.82972C16.3017 7.96066 16.3469 8.15459 16.2875 8.32997L15.5716 10.4407L16.9046 12.227C17.0154 12.3754 17.0323 12.5739 16.9482 12.7389C16.8641 12.9039 16.6937 13.0068 16.5085 13.0045L14.2799 12.976L12.9929 14.7957C12.886 14.9469 12.7025 15.0243 12.5197 14.9953C12.3368 14.9664 12.1862 14.8361 12.1312 14.6593V14.6593Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWandIcon);
export default __webpack_public_path__ + "static/media/MagicWandIcon.131b6746b94888d625c9fc8713a2453e.svg";
export { ForwardRef as ReactComponent };